import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const barcodeBars = [
  [4, 5, 1.1, 14],
  [6, 5, 0.7, 14],
  [7.8, 5, 1.4, 14],
  [10.2, 5, 0.6, 14],
  [11.6, 5, 1, 14],
  [13.6, 5, 1.6, 14],
  [16, 5, 0.8, 14],
  [17.6, 5, 1.2, 14],
  [19.4, 5, 0.6, 14],
];

export function BarcodeDetailIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {barcodeBars.map(([x, y, width, height]) => (
        <rect
          key={`${x}-${width}`}
          x={x}
          y={y}
          width={width}
          height={height}
          fill="currentColor"
        />
      ))}
    </SvgIcon>
  );
}

export function PalletDetailIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 7.5h4.5v3.5H5V7.5zm6.5 0H16v3.5h-4.5V7.5zM5 12h4.5v3.5H5V12zm6.5 0H16v3.5h-4.5V12zM3 17.5h18v1.5H3v-1.5zm2-1.5h2v1.5H5V16zm12 0h2v1.5h-2V16z"
      />
    </SvgIcon>
  );
}

export function LeafDetailIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M17 8C8 10 5.9 16.17 3.82 21.11l1.89.66.95-2.3c.48.17.98.3 1.34.3C16 20 22 15 22 8c0-2.5-2-5-5-5-2.5 0-4.5 1.5-5 2.5-.5-1-2.5-2.5-5-2.5S0 5.5 0 8c0 2 1.5 4 3.5 5.5C2 10 8 8 17 8z"
      />
    </SvgIcon>
  );
}
